import { formatSiteTime } from '@/lib/site-datetime';

/** Admin panelde hareketsizlik sonrası oturum süresi (1 saat) */
export const ADMIN_IDLE_TIMEOUT_MS = 60 * 60 * 1000;

export const ADMIN_SESSION_STORAGE_KEY = 'admin_session_expires_at';

export function initAdminSession(): number {
  const expiresAt = Date.now() + ADMIN_IDLE_TIMEOUT_MS;
  if (typeof window !== 'undefined') {
    localStorage.setItem(ADMIN_SESSION_STORAGE_KEY, String(expiresAt));
  }
  return expiresAt;
}

export function getAdminSessionExpiresAt(): number | null {
  if (typeof window === 'undefined') return null;
  const stored = localStorage.getItem(ADMIN_SESSION_STORAGE_KEY);
  if (!stored) return null;
  const ts = parseInt(stored, 10);
  return Number.isFinite(ts) ? ts : null;
}

export function extendAdminSession(): number {
  return initAdminSession();
}

export function clearAdminSession(): void {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(ADMIN_SESSION_STORAGE_KEY);
  }
}

export function formatSessionEndTime(expiresAt: number): string {
  return formatSiteTime(expiresAt, {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatRemainingTime(ms: number): string {
  if (ms <= 0) return 'Sona erdi';

  const totalSec = Math.ceil(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;

  if (h > 0) return `${h} sa ${m} dk`;
  if (m > 0) return `${m} dk ${s} sn`;
  return `${s} sn`;
}
